import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../stores/AuthContext';
import { trackLoginCompleted, trackLoginFailed } from '../../services/analytics';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();
  const [error, setError] = useState('');

  useEffect(() => {
    const processCallback = async () => {
      const hashParams = new URLSearchParams(window.location.hash.substring(1));
      const accessToken = hashParams.get('access_token');
      const refreshToken = hashParams.get('refresh_token');

      if (!accessToken || !refreshToken) {
        navigate('/login?error=oauth_failed', { replace: true });
        return;
      }

      const success = await handleOAuthCallback(accessToken, refreshToken);

      if (success) {
        trackLoginCompleted({ method: 'google' });
        navigate('/dashboard', { replace: true });
      } else {
        trackLoginFailed({ method: 'google', error_message: 'OAuth callback failed' });
        setError('Failed to complete sign-in. Please try again.');
        setTimeout(() => navigate('/login?error=oauth_failed', { replace: true }), 2000);
      }
    };

    processCallback();
  }, [handleOAuthCallback, navigate]);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center">
      {error ? (
        <div className="text-center">
          <p className="text-destructive text-lg">{error}</p>
          <p className="text-muted-foreground text-sm mt-2">Redirecting to login...</p>
        </div>
      ) : (
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-muted-foreground">Completing sign-in...</p>
        </div>
      )}
    </div>
  );
};

export default AuthCallback;
